import React, { useState } from "react";
import OneCard from "./OneCard";
// import Card from "@mui/material/Card";
import {} from "./CardStyle.css";
import imgAvatar1 from "../../../assets/pic1.jpg";
import imgAvatar2 from "../../../assets/pic2.jpg";
import imgAvatar3 from "../../../assets/pic4.jpg";
import imgAvatar4 from "../../../assets/pic5.jpg";
import imgAvatar5 from "../../../assets/pic5.jpg";
import imgAvatar6 from "../../../assets/pic6.jpg";
import imgAvatar7 from "../../../assets/pic7.jpg";
import imgAvatar8 from "../../../assets/pic8.jpg";
// import { width } from "@mui/system";

const TeamMembors = () => {
  const [btnName, setbtnName] = useState("Explore More");

  const cardList = [
    {
      name: "Fahim Rahman",
      discription: "@rahman",
      imageAvatar: imgAvatar1,
    },
    {
      name: "Kazi Rahman",
      discription: "@Rahman",
      imageAvatar: imgAvatar2,
    },
    {
      name: "Masterero Ali",
      discription: "@Master",
      imageAvatar: imgAvatar3,
    },
    {
      name: "Alia Karon",
      discription: "@Alia",
      imageAvatar: imgAvatar4,
    },
    {
      name: "Masterero Ali",
      discription: "@rahman",
      imageAvatar: imgAvatar5,
    },
    {
      name: "Alia Karon",
      discription: "@Rahman",
      imageAvatar: imgAvatar6,
    },
    {
      name: "Fahim Rahman",
      discription: "@Master",
      imageAvatar: imgAvatar7,
    },
    {
      name: "Kazi Rahman",
      discription: "@Alia",
      imageAvatar: imgAvatar8,
    },
  ];

  const divSize = () => {
    if (btnName === "Hide") {
      document.getElementById("rowDiv").style.height = "238px";
      setbtnName("Explore More");
    } else {
      document.getElementById("rowDiv").style.height = "max-content";
      setbtnName("Hide");
    }
  };

  const team = (event) => {
    document.getElementById("rowDiv").classList.remove("flex-row-reverse");
    document.getElementById("btn2").classList.remove("active");
    document.getElementById("btn2").classList.add("removeactive");
    event.target.classList.add("active");
    event.target.classList.remove("removeactive");
  };
  const board = (event) => {
    document.getElementById("rowDiv").classList.add("flex-row-reverse");
    document.getElementById("btn1").classList.remove("active");
    document.getElementById("btn1").classList.add("removeactive");
    event.target.classList.add("active");
    event.target.classList.remove("removeactive");

    if (btnName === "Hide") {
      document.getElementById("rowDiv").style.height = "238px";
      setbtnName("Explore More");
    } else {
      document.getElementById("rowDiv").style.height = "max-content";
      setbtnName("Hide");
    }
  };

  // const divSize = () => {
  //   btnName === "Hide"
  //     ? (document.getElementById("rowDiv").style.height = "238px") &
  //     setbtnName("Explore More")
  //     : (document.getElementById("rowDiv").style.height = "max-content") &
  //     setbtnName("Hide");
  // };
  return (
    <div className="container">
      <div className="d-flex m-0 p-0 justify-content-center mb-2">
        <div>
          <h3 className="fw-bold fs-2 text-center">Valuable Team</h3>
          <p className="text-muted text-center">Bright future of bomise</p>
        </div>
      </div>
      <div className="my-5 d-flex justify-content-center">
        <button
          id="btn1"
          onClick={team}
          className="btn rounded-3 border-0 mx-1 active"
        >
          Team
        </button>
        <button
          id="btn2"
          onClick={board}
          className="btn rounded-3 removeactive"
        >
          Board
        </button>
      </div>
      <div
        id="rowDiv"
        className=" row d-flex  justify-content-center hightLess"
      >
        {Array.from(cardList).map((_, index) => (
          <OneCard
            name={cardList[index].name}
            imageAvatar={cardList[index].imageAvatar}
            discription={cardList[index].discription}
          />
        ))}
      </div>
      <p className=" d-flex  justify-content-center">
        <button type="button" onClick={divSize} className="btn btn-primary">
          {btnName}
        </button>
      </p>
    </div>
  );
};

export default TeamMembors;
